//set the value of a drop down box
ht.setDDLB = function (opts) {
  $(opts.target + ' option:selected').val(opts.value);
};
